import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import { useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import 'react-datepicker/dist/react-datepicker.css';

import { messages } from './CcdaOptionsForm.i18n';
import CalendarCustomInput from './CalendarCustomInput';

function DateRange({ fieldsMeta, change, initFromDateInvalid, initToDateInvalid }) {
  const {
    startDate,
    endDate,
    fromDateInvalid,
    toDateInvalid,
  } = fieldsMeta;

  const { formatMessage } = useIntl();

  const language = useSelector((state) => state.language.languageCode)

  const handleOnChangeRaw = (e, onChangeFunction) => {
    const newDate = new Date(e.currentTarget.value);
    if (newDate instanceof Date && !isNaN(newDate)) {
      onChangeFunction(newDate);
    }
  };

  const onFromDateChange = (fromDate) => {
    change('startDate', fromDate);
    initFromDateInvalid();
  }

  const onToDateChange = (toDate) => {
    change('endDate', toDate);
    initToDateInvalid();
  }

  const handleDateFocus = () => {
    // Clear the recentVisitIndex selection
    change('radioValueField', 'daterange');
    change('recentVisitIndexField', -1);
  }

  return (
    <div className="row g-3 align-items-center mb-3 marginlr20">
      <div className="col-5">
      <span className={fromDateInvalid ? 'has-error' : ''}>
        <DatePicker id={startDate.input.name}
          name={startDate.input.name}
          dateFormat="MMM d, yyyy"
          className="form-control"
          locale={language}
          selected={startDate.input.value}
          onChange={onFromDateChange}
          onChangeRaw={(e) => handleOnChangeRaw(e, onFromDateChange)}
          onFocus={handleDateFocus}
          showMonthDropdown
          showYearDropdown
          dropdownMode="scroll"
          customInput={
            <CalendarCustomInput
              aria-label={formatMessage(messages.page.form.label.clearStartDateHint)}
              id={'input_' + startDate.input.name}
            />
          }
          showPopperArrow={false}
        />
      </span>
      </div>
      <div className="col-2">
      <span className="date-range-to"><FormattedMessage {...messages.page.tolabel} /></span>
      </div>
      <div className="col-5">
      <span className={toDateInvalid ? 'has-error' : ''}>
        <DatePicker id={endDate.input.name}
          name={endDate.input.name}
          dateFormat="MMM d, yyyy"
          className="form-control"
          locale={language}
          selected={endDate.input.value}
          onChange={onToDateChange}
          onChangeRaw={(e) => handleOnChangeRaw(e, onToDateChange)}
          onFocus={handleDateFocus}
          showMonthDropdown
          showYearDropdown
          dropdownMode="scroll"
          customInput={
            <CalendarCustomInput
              aria-label={formatMessage(messages.page.form.label.clearEndDateHint)}
              id={'input_' + endDate.input.name}
            />
          }
          showPopperArrow={false}
        />
      </span>
      </div>
      <label id="startDate_hint" className="sr-only" htmlFor={startDate.input.name}>
        <FormattedMessage {...messages.page.form.label.startDateHint} />&nbsp;
        { (fromDateInvalid) &&
          <FormattedMessage {...messages.page.form.error.required} />}
      </label>
      <label id="endDate_hint" className="sr-only" htmlFor={endDate.input.name}>
        <FormattedMessage {...messages.page.form.label.endDateHint} />&nbsp;
        { (toDateInvalid) &&
          <FormattedMessage {...messages.page.form.error.required} />}
      </label>
    </div>
  );
}

DateRange.propTypes = {
  fieldsMeta: PropTypes.object,
  change: PropTypes.func,
  initFromDateInvalid: PropTypes.func,
  initToDateInvalid: PropTypes.func,
}

export default DateRange;